export default __webpack_public_path__ + "static/media/clap.4835e848.png";